let player;
let fetching_data = false;

export const init = async (sonikit, audioPlayer) => {
  const playerTarget = document.createElement('div')
  playerTarget.style.display = 'none'
  playerTarget.id = 'sonikit-yt-player'
  document.body.appendChild(playerTarget)

  const onPlayerReady = (event) => {
    if (audioPlayer.service.media_type === 'video') {
      player.loadVideoById({ videoId: audioPlayer.service.media_id })
    } else if (audioPlayer.service.media_type === 'playlist') {
      player.loadPlaylist({ list: audioPlayer.service.media_id, listType: 'playlist' })
    }
    event.target.playVideo();
  }
  const onPlayerStateChange = (event) => {
    // -1 – unstarted
    // 0 – ended
    // 1 – playing
    // 2 – paused
    // 3 – buffering
    // 5 – video cued
    let playbackState;
    if (event.data === 1) {
      playbackState = 'playing'
    } else {
      playbackState = 'paused'
    }

    audioPlayer.setState(playbackState);
    getVideoData(sonikit)
  }

  player = new window.YT.Player('sonikit-yt-player', {
    height: '390',
    width: '640',
    //videoId: 'hlQtPvaFUKI',//audioPlayer.service.media_id,
    playerVars: {
      'playsinline': 1
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
  return player
}

const getVideoData = async (sonikit) => {
  try {
    if (fetching_data) return;

    const video_url = player.getVideoUrl();
    if (!video_url) return;
    const url_split = video_url.split('v=')[1];
    if (!url_split) return;

    const video_id = url_split.split('&')[0];
    if (!video_id || video_id === sonikit.player.currentTrack.id) return;

    fetching_data = true;
    const response = await fetch(`${sonikit.base_url}/services/${sonikit.player.service.id}/media?media_type=video&media_id=${video_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sonikit.player.patch.project}`
      }
    })
    
    if (!response.ok) {
      console.log('YT media error: ', response.status)
      fetching_data = false;
      // Update player id here so it doesn't keep re-trying a failed ID.
      // If ID is not set, it'll see that the video ID and player ID don't match so it'll look again
      // and return the same error.
      const track = { id: video_id }; 
      sonikit.player.updateTrack(track);
      return
    }

    const data = await response.json()

    fetching_data = false;

    const track = {
      id: data.id,
      artist: data.artist,
      title: data.title,
      image_url: data.image_url
    }
    
    sonikit.player.updateTrack(track);
  } catch (error) {
    console.log("YT media player error: ", error);
  }
}